{
  "de": {
    "paginator": {
      "labels": {
        "perPage": "Pro Seite",
        "pages": "%{page} von %{total}"
      }
    }
  }
}
